import { useState } from 'react';
import * as S from './styled';
import type { QATimerControlsTheme } from './styled';

interface QATimerControlsProps {
  isVisible: boolean;
  toggleTimer: (seconds: number) => void;
  theme?: QATimerControlsTheme;
}

export const QATimerControls = ({
  isVisible,
  toggleTimer,
  theme = 'light',
}: QATimerControlsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!isVisible) return null;

  const handleTimerAction = (seconds: number) => {
    toggleTimer(seconds);
    setIsOpen(false);
  };

  return (
    <S.Container>
      {isOpen && (
        <S.Panel $theme={theme}>
          <S.PanelTitle $theme={theme}>QA timer</S.PanelTitle>
          <S.ActionButton $theme={theme} id="reset-timer" onClick={() => handleTimerAction(0)}>
            Reset timer
          </S.ActionButton>
          <S.ActionButton $theme={theme} id="set-timer" onClick={() => handleTimerAction(60)}>
            Set timer 1:00
          </S.ActionButton>
        </S.Panel>
      )}
      <S.ToggleButton
        onClick={() => setIsOpen(!isOpen)}
        $isOpen={isOpen}
        $theme={theme}
        aria-label="QA timer controls"
      >
        {isOpen ? '✕' : 'QA'}
      </S.ToggleButton>
    </S.Container>
  );
};
